module.exports = __webpack_public_path__ + "media/customizations/rksouthhoa/back-c3a1d109b2d805410aa09e532e6d19c4.jpg";